const MONTH_ROLE_TAGS = Array.from({ length: 12 }, (_, index) => `month_${index + 1}`).reduce((accumulator, roleId) => ({
    ...accumulator,
    [roleId]: ['temporal', 'forecast'],
}), {});
export const ROLE_SEMANTIC_TAGS = {
    message: ['diagnostic', 'self-study'],
    past: ['temporal', 'causal'],
    present: ['temporal', 'diagnostic'],
    future: ['temporal', 'forecast'],
    situation: ['diagnostic', 'causal'],
    action: ['decision', 'diagnostic'],
    outcome: ['forecast', 'diagnostic'],
    obstacle: ['conflict', 'diagnostic'],
    advice: ['diagnostic', 'self-study'],
    self: ['relational', 'self-study'],
    other: ['relational', 'diagnostic'],
    bond: ['relational', 'conflict'],
    challenge: ['conflict', 'initiatic'],
    resource: ['healing', 'diagnostic'],
    option_a: ['decision', 'forecast'],
    option_b: ['decision', 'forecast'],
    option_c: ['decision', 'forecast'],
    consequence_a: ['decision', 'forecast'],
    consequence_b: ['decision', 'forecast'],
    hidden: ['introspective', 'shadow-work'],
    shadow: ['shadow-work', 'introspective'],
    desire: ['shadow-work', 'relational'],
    wound: ['shadow-work', 'healing'],
    temptation: ['shadow-work', 'conflict'],
    repressed_power: ['shadow-work', 'initiatic'],
    chain: ['shadow-work', 'healing'],
    truth: ['introspective', 'initiatic'],
    ritual_action: ['ritual', 'healing'],
    integration: ['healing', 'initiatic'],
    significator: ['diagnostic', 'ritual'],
    mask: ['shadow-work', 'relational'],
    cost: ['decision', 'forecast'],
    ...MONTH_ROLE_TAGS,
};
export const SPREAD_SEMANTIC_TAGS = {
    'single-card': ['diagnostic', 'self-study'],
    'past-present-future': ['temporal', 'forecast'],
    'situation-action-outcome': ['causal', 'decision', 'diagnostic'],
    'celtic-cross': ['diagnostic', 'forecast', 'self-study'],
    horseshoe: ['diagnostic', 'forecast', 'temporal'],
    'daily-triad': ['ritual', 'self-study'],
    'shadow-base': ['shadow-work', 'healing', 'introspective'],
    'option-a-option-b': ['decision', 'diagnostic'],
    'relationship-two-polarities': ['relational', 'conflict', 'diagnostic'],
    'annual-wheel': ['temporal', 'forecast', 'ritual'],
    'amore-dinamica-di-coppia': ['relational', 'conflict', 'forecast'],
    'relationship-check-in': ['relational', 'diagnostic'],
    'nuova-connessione': ['relational', 'forecast'],
    'confine-relazionale': ['relational', 'healing'],
    'decisione-critica': ['decision', 'diagnostic'],
    'three-paths': ['decision', 'forecast'],
    'causa-nodo-scelta-costo-esito': ['decision', 'causal'],
    timeline: ['temporal', 'forecast'],
    'life-cycle': ['temporal', 'initiatic', 'self-study'],
    'stesa-ombra': ['shadow-work', 'introspective'],
    'guarigione-interiore': ['healing', 'shadow-work'],
    'catena-ferita-potere': ['shadow-work', 'healing', 'initiatic'],
    'discesa-integrazione': ['shadow-work', 'initiatic', 'healing'],
    'mind-body-spirit': ['self-study', 'healing'],
    'guida-interiore': ['self-study', 'ritual'],
    'percorso-spirituale': ['initiatic', 'ritual', 'self-study'],
    'chiamata-iniziazione': ['initiatic', 'ritual'],
    'specchio-di-lilith': ['shadow-work', 'initiatic', 'ritual', 'relational'],
    'specchio-di-lilith-lite': ['shadow-work', 'ritual'],
    'tree-of-life': ['initiatic', 'ritual', 'self-study'],
    'sentiero-dominante': ['initiatic', 'self-study'],
    'ponte-sephirotico': ['initiatic', 'healing', 'ritual'],
};
//# sourceMappingURL=semantic-tags.js.map